import React, { useEffect, useState } from "react";
import FieldLoader from "../../../../components/UI/FieldLoader";
import PERMISSIONS from "../../../../utils/AclPermissions";
import Buttons from "../../../../components/UI/Buttons";
import { isSet } from "../../../../utils/commonUtils";
import FormInputs from "../../../../components/UI/FormInputs";
import EmrVisitsService from "../../../../services/EmrVisitsService";
import { createPortal } from "react-dom";
import Alert from "../../../../components/UI/ConfirmBox/Alert";

const ConfidentialNotes = (props) => {
  const [isLoading, setLoading] = useState();
  const [notes, setNotes] = useState("");
  const { visit_id, employeeId, selectedSubTab } = props;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  useEffect(() => {
    if (visit_id && selectedSubTab) {
      fetchNotes();
    }
  }, [visit_id, selectedSubTab]);
  const fetchNotes = async () => {
    setLoading(true);
    const response = await EmrVisitsService.getChartNotes(
      selectedSubTab,
      visit_id
    );
    const { data } = response;
    setLoading(false);
    setNotes(data?.note);
  };
  const handleUpdate = async (isClear = false, paramsNote = notes) => {
    const payload = {
      note: isClear ? "" : paramsNote,
      employee_id: employeeId,
    };
    setLoading(true);
    await EmrVisitsService.saveChartNotes(selectedSubTab, visit_id, payload);
    setLoading(false);
    if (isClear) {
      setShowDeleteModal(false);
    }
    fetchNotes();
  };

  const handleNotesChange = (value) => {
    setNotes(value);
  };
  return (
    <>
      {showDeleteModal &&
        createPortal(
          <Alert
            onDelete={() => handleUpdate(true, "")}
            onClose={() => setShowDeleteModal(false)}
            content="Do you really want to Clear this record?"
          />,
          document.body
        )}
      <div className="sh_cardBody py-0" >
        <div className="sh_emrtextareabox p-1 position-relative">
          <FieldLoader isLoading={isLoading} />
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="text-sm font-weight-bold  mb-0">
              Confidential Notes
            </h5>
            <div className="d-flex" style={{ gap: "5px" }}>
              <Buttons
                className="btn mb-1 btn-primary"
                clickHandler={() => handleUpdate(false, notes)}
                label={"Update"}
              />
              <Buttons
                acl={
                  isSet(notes, false)
                    ? PERMISSIONS.ANY_PERMISSION
                    : PERMISSIONS.NO_PERMISSION
                }
                className="btn mb-1  sh_btnlight"
                clickHandler={() => setShowDeleteModal(true)}
                label={"Clear All"}
              />
            </div>
          </div>
          <FormInputs
            type="Editor"
            value={notes}
            formats={{
              formats: ["background"],
            }}
            modules={{
              toolbar: [
                ["bold"],
                [{ background: ["yellow", "red", "green", "blue"] }],
                ["clean"],
              ],
            }}
            changeHandler={handleNotesChange}
            height={"680px"}
          />
        </div>
      </div>
    </>
  );
};

export default ConfidentialNotes;
